import React from "react";
import { useTranslation } from "react-i18next";
import BaseButton from "../../../../components/BaseButton";
import useController from "./controller";
import CreateNewGame from "../CreateNewGame";
import UnpurchasedNewGame from "../UnpurchasedNewGame";
import "./style.scss";
import { observer } from "mobx-react-lite";
import BaseSpinner from "../../../../components/BaseSpinner";
import ROUTES from "../../../../utils/routes.js";

export default observer(function NewGame() {
  const {
    isGameCreated,
    isGamePurchased,
    isGameCreating,
    createNewGame,
    removeGame,
    buyGame,
    newGame,
  } = useController();
  return (
    <div>
      {isGameCreated &&
        newGame.map((game) => {
          return (
            <UnpurchasedNewGame
              key={game.id}
              game={game}
              removeGame={removeGame}
              buyGame={buyGame}
            />
          );
        })}
      {isGameCreating ? <BaseSpinner /> : null}
      {!isGameCreated && !isGamePurchased && !isGameCreating ? (
        <div className="action-new-game">
          <CreateNewGame createNewGame={createNewGame} />
        </div>
      ) : null}
    </div>
  );
});
